/**
 * Склеює класи, відкидаючи порожні.
 *
 * Потрібен через дві налаштовані в проєкті строгості, які разом роблять роботу
 * з CSS-модулями незручною:
 *
 *   - `noPropertyAccessFromIndexSignature` — до класу можна звернутися лише
 *     квадратними дужками (`styles['root']`);
 *   - `noUncheckedIndexedAccess` — і результат такого звернення завжди
 *     `string | undefined`, бо TypeScript не знає переліку класів у файлі.
 *
 * Передати `string | undefined` у `className?: string` не можна:
 * `exactOptionalPropertyTypes` відрізняє «пропса немає» від «пропс —
 * undefined». Звідси й помилки, яких було півтора десятка.
 *
 * ⚠️ Шаблонний рядок цю проблему не вирішує, а ховає: `` `${styles['nope']}` ``
 * мовчки дає клас «undefined» у розмітці. Тут відсутній клас просто зникає.
 */
export const classNames = (...names: Array<string | false | null | undefined>): string =>
    names.filter((name): name is string => typeof name === 'string' && name !== '').join(' ')
